import { useTranslation } from 'react-i18next'
import { useAuth } from '@/contexts/AuthContext'
import SidebarLayout from '@/components/common/SidebarLayout'
import UserMenu from '@/components/common/UserMenu'
import StudentPopupManager from '@/components/common/StudentPopupManager'
import {
  Home,
  BookOpen,
  Video,
  Award,
  PlayCircle,
  Flame,
  Star,
} from 'lucide-react'

export default function MainLayout() {
  const { t } = useTranslation()
  const { student, isInCohort } = useAuth()
  const isPremium = student?.subscription_status === 'active'
  const hasFullAccess = isPremium && isInCohort
  const isPaidWaiting = isPremium && !isInCohort

  const navigation = [
    { name: t('nav.dashboard'), href: '/dashboard', icon: Home },
    { name: t('nav.lessons'), href: '/units', icon: BookOpen },
    { name: t('nav.workshops'), href: '/workshops', icon: Video, locked: !hasFullAccess && !isPaidWaiting, waiting: isPaidWaiting },
    { name: 'Talleres grabados', href: '/recorded-workshops', icon: PlayCircle, locked: !hasFullAccess && !isPaidWaiting, waiting: isPaidWaiting },
    { name: t('nav.badges'), href: '/badges', icon: Award },
  ]

  return (
    <SidebarLayout
      navigation={navigation}
      dashboardHref="/dashboard"
      sidebarFooter={
        student ? (
          <div className="p-4 border-t space-y-3">
            <div className="flex items-center gap-3 text-sm">
              <Star className="w-5 h-5 text-yellow-500" />
              <span>{student.total_points} {t('gamification.points')}</span>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Flame className="w-5 h-5 text-orange-500" />
              <span>{student.streak_days} {t('gamification.streakDays')}</span>
            </div>
          </div>
        ) : undefined
      }
      headerActions={
        <>
          {student && (
            <div className="flex items-center gap-4 lg:hidden">
              <div className="flex items-center gap-1 text-sm">
                <Star className="w-4 h-4 text-yellow-500" />
                <span>{student.total_points}</span>
              </div>
              <div className="flex items-center gap-1 text-sm">
                <Flame className="w-4 h-4 text-orange-500" />
                <span>{student.streak_days}</span>
              </div>
            </div>
          )}
          <UserMenu settingsHref="/settings" />
        </>
      }
      floatingElement={<StudentPopupManager />}
    />
  )
}
